import { ArrowUp, ArrowDown, ArrowSquareOut } from '@phosphor-icons/react';
import { formatCurrency, formatNumber } from '@/lib/utils';

export default function StatsCard({ 
  title, 
  value, 
  change, 
  changeLabel, 
  isCurrency = true,
  format,
  icon: Icon,
  subtitle,
  onClick,
  className = ''
}) {
  const isPositive = change >= 0;
  const formattedValue = format === 'number' ? formatNumber(value || 0) : isCurrency ? formatCurrency(value) : formatNumber(value);
  const isClickable = !!onClick;
  
  return (
    <div 
      className={`stats-card card-hover ${isClickable ? 'cursor-pointer group' : ''} ${className}`} 
      data-testid={`stats-card-${title.toLowerCase().replace(/\s+/g, '-')}`}
      onClick={onClick}
      role={isClickable ? 'button' : undefined}
      tabIndex={isClickable ? 0 : undefined}
    >
      <div className="flex items-start justify-between">
        <div>
          <p className="stats-card-label">{title}</p>
          <p className="stats-card-value">{formattedValue}</p>
          {subtitle && <p className="text-[10px] text-[#64748B] mt-0.5">{subtitle}</p>}
        </div>
        <div className="flex items-center gap-1">
          {Icon && (
            <div className="p-2 rounded-lg bg-[#E2E8F0]">
              <Icon size={20} className="text-[#0F4C81]" weight="duotone" />
            </div>
          )}
          {isClickable && (
            <ArrowSquareOut size={14} className="text-[#64748B] opacity-0 group-hover:opacity-100 transition-opacity" />
          )}
        </div>
      </div>
      {change !== undefined && (
        <div className={`stats-card-change ${isPositive ? 'positive' : 'negative'}`}>
          <span className="inline-flex items-center gap-1">
            {isPositive ? <ArrowUp size={14} /> : <ArrowDown size={14} />}
            {Math.abs(change).toFixed(1)}%
          </span>
          {changeLabel && <span className="text-[#64748B] ml-1">{changeLabel}</span>}
        </div>
      )}
      {isClickable && (
        <p className="text-[9px] text-[#64748B] mt-1 opacity-0 group-hover:opacity-100 transition-opacity">Click to drill down</p>
      )}
    </div>
  );
}
